<template>
    <div class="base-block" :class="{ 'bottom-line': setOnePxLine, 'canClick': canClick }" @click="blockClicked">
      <div class="base-block-left fx-v-center">
        <span>{{ des }}</span>
      </div>
      <div class="base-block-right fx-v-center" :class="{mr: rightInfo !== '' && canClick}">
        <span class="l" v-if="(leftInfo && isPC()) || !isBreakWord">{{leftInfo}}</span>
        <span class="l" v-else-if="leftInfo">
          <p>{{ leftInfo.slice(0, 8) }}</p>
          <p v-if="leftInfo.length > 8">{{ leftInfo.slice(8) }}</p>
        </span>
        <slot name="rightInfo"/>
        <span class="r" v-if="rightInfo">{{ rightInfo }}</span>
        <img class="arrow-right" src='~@/assets/images/arrow_right.svg' v-if="canClick"/>
      </div>
    </div>
</template>

<script>
import { isPC } from '@/assets/js/util' 

export default {
    props: {
      des: String,
      isBreakWord: {
        type: Boolean,
        default: false
      },
      leftInfo: [String, Number],
      rightInfo: [String, Number],
      setOnePxLine: {
        type: Boolean,
        default: true
      },
      canClick: {
        type: Boolean,
        default: false
      }
    },

    created() {
      this.emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      this.isPC = isPC
    },

    methods: {
      blockClicked() {
        if (this.canClick) {
          this.$emit('click');
        }
      }
    }
}
</script>

<style lang="scss" scoped>
.fx-v-center {
  display: flex;
  align-items: center;
}

.base-block {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px; 
  padding: 0 10px;
  letter-spacing: 0.24px;
  color: #333;
  background: #fff;

  &.bottom-line::after {
    content: '';
    position: absolute;
    left: 10px;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #eee;
    transform: scaleY(0.5);
  }

  &.canClick:hover {
    background: rgba(0, 0, 0, .05);
  }

  &-right {

    &.mr {
      font-size: 14px;

      .l {
        margin-right: 20px;
      }

      .r {
        margin-right: 10px;
        color: #3C90FF;
        cursor: pointer;
      }
    }

    .arrow-right {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
